import VueRouter from 'vue-router';
import Vue from 'vue';
import Search from './components/PropertySearch/Search';
import mediaIndex from './components/admin/media-resources/index';
import mediaCreate from './components/admin/media-resources/create';
import mediaEdit from './components/admin/media-resources/edit';
import logosApp from './components/logos-app';
import peopleIndex from './components/admin/people/index';
import peopleCreate from './components/admin/people/create';
import peopleEdit from './components/admin/people/edit';
import peopleView from './components/admin/people/view';
import categoryIndex from './components/admin/category/index';
window.axios = require('axios');
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.Vue = Vue;
Vue.use(VueRouter);
// let Search = require('./components/PropertySearch/Search');
let router = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/property-search', component: Search, props: true},
        {path: '/logos', component: logosApp, props: true},
        {path: '/about-us/:type', component: peopleView, props: true},
        {path: '/admin/media', component: mediaIndex, props: true},
        {path: '/admin/media/create', component: mediaCreate, props: true},
        {path: '/admin/media/:id/edit', component: mediaEdit, props: true},
        {path: '/admin/people', component: peopleIndex, props: true},
        {path: '/admin/people/create', component: peopleCreate, props: true},
        {path: '/admin/people/:id/edit', component: peopleEdit, props: true},
        {path: '/admin/category', component: categoryIndex, props: true},
    ]
});
const app = new Vue({
    el: '#VueApp',
    render: h => h('router-view'),
    router,
    components: {Search, logosApp},
});


// WEBPACK FOOTER //
// ./resources/assets/js/VueApp.js